import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { ref } from "vue";
import { Training } from "@/types/training/Training";
import { useModal } from "@/utils/modal";
import { onMounted } from "vue";
import { onUnmounted } from "vue";
import { computed } from "vue";
import router from "@/router";
import Question from "./organisms/Question.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const modal = useModal();

const training = ref<Training | null>(null);
const transitionDisabled = computed(() => {
  return router.currentRoute.value.query.transition === "false";
});

onMounted(() => {
  registerEvents();
  fireInitEvent();
});

onUnmounted(() => {
  unregisterEvents();
});

function registerEvents() {
  window.addEventListener("message", onMessage);
}

function unregisterEvents() {
  window.removeEventListener("message", onMessage);
}

function fireInitEvent() {
  // トレーニングプレビューが準備完了したことを通知
  if (!window.opener) return;
  window.opener.postMessage({ type: "trainingPreviewReady" }, "*");
}

function onMessage(event: MessageEvent) {
  if (event.data.type !== "training") return;

  training.value = event.data.value;
}

async function onTrainingFinished() {
  await modal.msgBoxOk("これで終了です。お仕事頑張ってください！", {
    centered: true
  });
}

return (_ctx: any,_cache: any) => {
  return (training.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Question, {
          training: training.value,
          onFinish: onTrainingFinished,
          "transition-disabled": transitionDisabled.value
        }, null, 8, ["training", "transition-disabled"])
      ]))
    : _createCommentVNode("", true)
}
}

})